module.exports = __webpack_public_path__ + "img/s5.56c69a24.jpg";